import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
  TablePagination,
  Box,
  Card,
  Tooltip,
  List,
  CardActions,
  CardContent,
} from "@material-ui/core";
import CardHeader from "@material-ui/core/CardMedia";
import PageTitle from "../../../../components/PageTitle/PageTitle.js";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import useStyles from "../../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../css/employee-page.css";
import { useNotification } from "../../../../hooks/useNotification.js";
import MUIDataTable from "mui-datatables";

import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import CloseIcon from "@material-ui/icons/Close";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

export default function RepliedOpinions() {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const handleNotificationCall = useNotification();

  const [loader, setLoader] = useState(false);
  const [opinionRepliedData, setOpinionRepliedData] = useState([]);
  const [viewRepliedData, setViewRepliedData] = useState({});

  const handleViewReplyData = (item) => {
    setViewRepliedData({ ...item });
    toggleDrawer("right", true)();
  };

  const [state, setState] = useState({
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const validationSchema = Yup.object().shape({
    startTime: Yup.string().required("Start Time is required").nullable(),
    duration: Yup.string().required("Duration is required"),
    reason: Yup.string().required("Leave Reason is required"),
  });

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      startTime: null,
      duration: "1hour",
      endTime: null,
      reason: "",
    },
  });

  // Watch for changes
  const startTime = watch("startTime");
  const duration = watch("duration");

  useEffect(() => {
    if (startTime && duration) {
      let endTime = moment(startTime);
      if (duration === "1hour") {
        endTime = endTime.add(1, "hour");
      } else if (duration === "2hour") {
        endTime = endTime.add(2, "hour");
      }
      setValue("endTime", endTime.toDate());
    }
  }, [startTime, duration, setValue]);

  useEffect(() => {
    fetchPermissionsData();
  }, []);

  const fetchPermissionsData = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}opinions/viewAllOpinions`,
        data: {
          page: currerntPage,
          isReplied: true,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setOpinionRepliedData(response.data.data);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    var data = JSON.stringify({
      page: newPage + 1,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}permission/viewAllPermissions`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setOpinionRepliedData(response.data.data);
        setCount(response.data.count);
      }
      setLoader(false);
    });
  };

  function getEmpName(user) {
    let empName;
    if (user.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  const HeaderElements = () => <>Total : {count}</>;

  const list = (anchor) => (
    <>
      <Box sx={{ width: "100%", padding: "0 20px" }} role="presentation">
        <List>
          <Card className={classes.root} px={3}>
            <CardHeader>
              <Grid
                container
                direction="row"
                spacing={1}
                className={classes.drawerHeader}
              >
                <Typography variant="subtitle1">
                  {" "}
                  {viewRepliedData?.type} Details
                </Typography>

                <Grid className={classes.drawerClose}>
                  <CloseIcon
                    className={classes.closeBtn}
                    size="14px"
                    onClick={toggleDrawer(anchor, false)}
                  />
                </Grid>
              </Grid>
            </CardHeader>
            <CardContent className={classes.drawerViewContent}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>Name: </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewRepliedData.user && getEmpName(viewRepliedData?.user)}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Role Type:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewRepliedData?.user?.roleName}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Posted Date:{" "}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {moment(viewRepliedData?.createdAt).format("DD-MM-YYYY")}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    {viewRepliedData?.type}:{" "}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}></Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    padding: "10px",
                    paddingTop: "0px",
                    minHeight: "100px",
                  }}
                >
                  <p
                    style={{
                      margin: "6px 0px",
                      fontStyle: "italic",
                      color: "#454545",
                      fontSize: "16px",
                    }}
                  >
                    {viewRepliedData?.title}
                  </p>
                  {viewRepliedData?.description}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>Reply: </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}></Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    minHeight: "100px",
                  }}
                >
                  {viewRepliedData?.reply}
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <Grid
                container
                direction="row"
                spacing={2}
                className={classes.drawerFooter}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={toggleDrawer(anchor, false)}
                >
                  Close
                </Button>
              </Grid>
            </CardActions>
          </Card>
        </List>
      </Box>
    </>
  );

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid item xs={12}>
        <MUIDataTable
          title=""
          options={{
            textLabels: {
              body: {
                noMatch: "Oops! Matching record could not be found",
              },
            },
            pagination: false,
            sort: false,
            selectableRows: "none",
            search: false,
            filter: false,
            download: false,
            print: false,
            customToolbar: () => <HeaderElements />,
            responsive: mobileQuery === true ? "vertical" : "standard",
          }}
          columns={[
            {
              name: "S.No",
            },
            {
              name: "Employee Name",
            },
            {
              name: "Opinion Type",
            },
            {
              name: "Title",
            },
            {
              name: "Posted Date",
            },
            {
              name: "Action",
            },
          ]}
          data={opinionRepliedData.map((item, index) => {
            return [
              <>
                {currerntPage !== 0
                  ? 10 * currerntPage - 10 + index + 1
                  : index + 1}
              </>,
              getEmpName(item.user),
              item.type,
              <span
                style={{
                  width: "350px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.title}
              </span>,

              moment(item.createdAt).format("DD-MM-YYYY"),
              <>
                <Tooltip title="View JD" placement="bottom" aria-label="view">
                  <RemoveRedEyeIcon
                    className={classes.toolIcon}
                    onClick={() => handleViewReplyData(item)}
                  />
                </Tooltip>
              </>,
            ];
          })}
        />

        <Grid container spacing={2} className={classes.pagination}>
          <TablePagination
            rowsPerPageOptions={[50]}
            component="div"
            count={count}
            rowsPerPage={10}
            page={page}
            onPageChange={handleChangePage}
          />
        </Grid>
      </Grid>

      <SwipeableDrawer
        anchor="right"
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
        classes={{ paper: classes.drawer }}
      >
        {list("right")}
      </SwipeableDrawer>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
